import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "../../../../Assets/Images/closeico--userdb.svg";
import CollapseIcon from "../../../../Assets/Images/collapsed--ico.svg";
import CheckBlueIcon from "../../../../Assets/Images/checkblue.svg";


import "./formStyle.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { getLocalStorageJSON } from "../../../../Utils/localStorageFunc";
import { MAIN_URL } from "../../../../Configs/Urls";

// when for a trip all unblocked travellers are selected + prceed to ignore is 0 then show that alrert

const areAllTripsDisabled = (MainForm) => {
  if (!MainForm?.data?.form_data?.length) return false;

  return MainForm.data.form_data.every((trip) => isTripPastOrDeparted(trip));
};

const isTripPastOrDeparted = (trip) => {
  if (!trip?.Data?.length) return false;

  const departureTimes = trip.Data
    .map((d) => d.departure_date_and_time ? new Date(d.departure_date_and_time) : null)
    .filter((d) => d && !isNaN(d.getTime()));

  if (departureTimes.length === 0) return false;

  const earliestDeparture = new Date(
    Math.min(...departureTimes.map((d) => d.getTime()))
  );

  const now = new Date();

  return earliestDeparture <= now;
};

const isFramePastOrDeparted = (frame) => {
  if (!frame?.departure_date_and_time) return false;
  const d = new Date(frame.departure_date_and_time);
  if (isNaN(d.getTime())) return false;
  return d <= new Date();
};

const isTripFullySelected = (trip, tripIndex, selectedTravellers) => {
  if (!trip?.Data) return false;

  const unblockedTravellers = trip.Data.flatMap((frame) =>
    frame.travellers.filter((t) => !t.is_blocked || t.available_for_other_enquiry)
  );

  if (unblockedTravellers.length === 0) return false;

  return unblockedTravellers.every((t) =>
    selectedTravellers.includes(t.ref_id)
  );
};

function CancellationForm({
  showbottombar,
  getApi,
  postApi,
  booking_id,
  onClose,
  autoFill,
  documentData,
  readOnly,
  formId,
  requestId,
}) {
  console.log("autoFill is ; ", autoFill);
  console.log("documentData is ; ", documentData);

  let [warningMessage, setWarningMessage] = useState("");


  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );


  const [loading, setLoading] = useState(true);
  const [MainForm, setMainForm] = useState(null);

  const [pendingEnquiry, setPendingEnquiry] = useState(null); // { has_pending, form_id, remarks }
  const [existingRemarks, setExistingRemarks] = useState([]);
  const [newRemark, setNewRemark] = useState("");
  const [remarkFiles, setRemarkFiles] = useState([]);
  const [savingRemark, setSavingRemark] = useState(false);
  const [remarkCooldownSecs, setRemarkCooldownSecs] = useState(0);
  const [selectedEnquiryTravellerIds, setSelectedEnquiryTravellerIds] = useState([]);

  const [Remarks, setRemarks] = useState({
    user_remarks_1: "",
    user_remarks_2: "",
    user_remarks_3: "",
    user_remarks_4: "",
  });

  const [ProceedMode, setProceedMode] = useState({
    proceed_mode_1: 0,
    proceed_mode_2: 0,
    proceed_mode_3: 0,
    proceed_mode_4: 0,
  });

  const [AcceptFareRules, setAcceptFareRules] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [Documents, setDocuments] = useState({
    trip_1: [],
    trip_2: [],
    trip_3: [],
    trip_4: [],
  });

  // Fix double-slash URLs stored before the .env was corrected
  const fixUrl = (url) => url ? url.replace(/([^:])\/\//g, "$1/") : url;

  const handleDocumentChange = (tripKey, files) => {
    const newDocs = Array.from(files).map((file) => ({
      name: file.name,
      url: URL.createObjectURL(file),
      isExisting: false,
      file,
    }));

    setDocuments((prev) => ({
      ...prev,
      [tripKey]: [...prev[tripKey], ...newDocs],
    }));
  };

  const removeDocument = (tripKey, index) => {
    setDocuments((prev) => ({
      ...prev,
      [tripKey]: prev[tripKey].filter((_, i) => i !== index),
    }));
  };

  console.log("Form is : ", MainForm);

  useEffect(() => {
    if (!booking_id) return;

    const fetchForm = async () => {
      try {
        setLoading(true);

        const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

        const res = await axios.get(`${getApi}/${booking_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("GET API RESPONSE => ", res.data);

        setMainForm(res.data);

        let maind = res.data.data;
        console.log("maind is : ", maind);

        setRemarks({
          user_remarks_1: maind.user_remarks_1 ?? "",
          user_remarks_2: maind.user_remarks_2 ?? "",
          user_remarks_3: maind.user_remarks_3 ?? "",
          user_remarks_4: maind.user_remarks_4 ?? "",
        });

        setProceedMode({
          proceed_mode_1: maind.proceed_mode_1 ?? 0,
          proceed_mode_2: maind.proceed_mode_2 ?? 0,
          proceed_mode_3: maind.proceed_mode_3 ?? 0,
          proceed_mode_4: maind.proceed_mode_4 ?? 0,
        });

        const initialOpen = {};

        res.data.data.form_data.forEach((_, idx) => {
          initialOpen[idx] = true;
        });

        setOpenTrips(initialOpen);

        const backendDocs = res.data.documents || [];

        const mappedDocs = {
          trip_1: [],
          trip_2: [],
          trip_3: [],
          trip_4: [],
        };

        backendDocs.forEach((doc) => {
          const tripKey = doc.document_for || "trip_1"; // fallback if null

          const fileName = doc.document_link.split("/").pop();

          if (mappedDocs[tripKey]) {
            mappedDocs[tripKey].push({
              name: fileName,
              url: doc.document_link,
              isExisting: true,
            });
          }
        });

        setDocuments(mappedDocs);
      } catch (err) {
        console.error("GET API FAILED => ", err);
      } finally {
        setLoading(false);
      }
    };

    // In readOnly mode, load the specific saved form + remarks
    if (readOnly && formId) {
      setPendingEnquiry({ has_pending: true, form_id: formId });
      const fetchSavedForm = async () => {
        try {
          setLoading(true);
          const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
          const [formRes, remarkRes] = await Promise.all([
            axios.get(`${MAIN_URL}bookings/flights/post-booking-form-by-id/${formId}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
            axios.get(`${MAIN_URL}bookings/flights/post-booking-form-remarks/${formId}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          ]);

          setMainForm(formRes.data);
          setExistingRemarks(remarkRes.data.remarks || []);

          setRemarks({
            user_remarks_1: formRes.data.user_remarks_1 ?? "",
            user_remarks_2: formRes.data.user_remarks_2 ?? "",
            user_remarks_3: formRes.data.user_remarks_3 ?? "",
            user_remarks_4: formRes.data.user_remarks_4 ?? "",
          });
          setProceedMode({
            proceed_mode_1: formRes.data.proceed_mode_1 ?? 0,
            proceed_mode_2: formRes.data.proceed_mode_2 ?? 0,
            proceed_mode_3: formRes.data.proceed_mode_3 ?? 0,
            proceed_mode_4: formRes.data.proceed_mode_4 ?? 0,
          });

          const initialOpen = {};
          (formRes.data.data?.form_data || []).forEach((_, idx) => {
            initialOpen[idx] = true;
          });
          setOpenTrips(initialOpen);

          const backendDocs = formRes.data.documents || [];
          const mappedDocs = { trip_1: [], trip_2: [], trip_3: [], trip_4: [] };
          backendDocs.forEach((doc) => {
            const tripKey = doc.document_for || "trip_1";
            const fileName = doc.document_link.split("/").pop();
            if (mappedDocs[tripKey]) {
              mappedDocs[tripKey].push({ name: fileName, url: doc.document_link, isExisting: true });
            }
          });
          setDocuments(mappedDocs);
          setSelectedEnquiryTravellerIds(formRes.data.selected_traveller_ids || []);
        } catch (err) {
          console.error("fetchSavedForm error", err);
        } finally {
          setLoading(false);
        }
      };
      fetchSavedForm();
      return; // skip fetchForm / checkPending below
    } else {
      // Check if a pending cancellation enquiry already exists for this booking
      const checkPending = async () => {
        try {
          const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
          const res = await axios.get(
            `${MAIN_URL}bookings/flights/check-pending-enquiry/${booking_id}/cancellation`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setPendingEnquiry(res.data);
          setExistingRemarks(res.data.remarks || []);
        } catch (err) {
          console.error("checkPendingEnquiry error", err);
        }
      };
      checkPending();
    }

    if (autoFill.autoFilled == false) {
      fetchForm();
    } else {
      setMainForm(autoFill.data);

      setRemarks({
        user_remarks_1: autoFill.data.data.user_remarks_1 ?? "",
        user_remarks_2: autoFill.data.data.user_remarks_2 ?? "",
        user_remarks_3: autoFill.data.data.user_remarks_3 ?? "",
        user_remarks_4: autoFill.data.data.user_remarks_4 ?? "",
      });

      setProceedMode({
        proceed_mode_1: autoFill.data.data.proceed_mode_1 ?? 0,
        proceed_mode_2: autoFill.data.data.proceed_mode_2 ?? 0,
        proceed_mode_3: autoFill.data.data.proceed_mode_3 ?? 0,
        proceed_mode_4: autoFill.data.data.proceed_mode_4 ?? 0,
      });

      const initialOpen = {};

      autoFill.data.data.form_data.forEach((_, idx) => {
        initialOpen[idx] = true;
      });

      setOpenTrips(initialOpen);

      setDocuments(documentData);

      setLoading(false);
    }
  }, [booking_id, autoFill, readOnly, formId]);

  const scrollRef = useRef(null);
  let [selectedTravellers, setSelectedTravelers] = useState([]);
  let [selectedStatuses, setSelectedStatuses] = useState([]);

  const [openTrips, setOpenTrips] = useState({});

  const toggleTrip = (index) => {
    setOpenTrips((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Returns all ref_ids + statusTypes for travellers with the same full_name
  // across every non-departed frame in the entire form.
  const getMatchingTravellers = (fullName, dob, tripIndex) => {
    const ids = [];
    const sts = [];
    if (!MainForm?.data?.form_data) return { ids, sts };
    const trips = tripIndex != null
      ? [MainForm.data.form_data[tripIndex]].filter(Boolean)
      : MainForm.data.form_data;
    trips.forEach((trip) => {
      trip.Data.forEach((frame) => {
        if (isFramePastOrDeparted(frame)) return;
        frame.travellers.forEach((t) => {
          if (t.full_name === fullName && t.date_of_birth === dob && (!t.is_blocked || t.available_for_other_enquiry)) {
            ids.push(t.ref_id);
            sts.push(...(t.statusTypes || []));
          }
        });
      });
    });
    return { ids, sts };
  };

  const getAutoCancelTrips = () => {
    if (!MainForm?.data?.form_data) return [];

    return MainForm.data.form_data
      .map((trip, index) => {
        const tripNo = index + 1;
        const fullySelected = isTripFullySelected(
          trip,
          index,
          selectedTravellers
        );
        const proceedMode = ProceedMode[`proceed_mode_${tripNo}`];

        if (fullySelected && proceedMode === 0) {
          return `Trip ${tripNo}`;
        }

        return null;
      })
      .filter(Boolean);
  };

  const allTripsDisabled = areAllTripsDisabled(MainForm);

  const handleSubmit = async () => {
    if (selectedTravellers.length === 0) {
      setWarningMessage(
        "Please select at least one traveller for Cancellation."
      );
      return;
    }

    if (allTripsDisabled) {
      setWarningMessage(
        "All trips have already departed. Cancellation is not allowed."
      );
      return;
    }

    if (!AcceptFareRules) {
      setWarningMessage("Please Accept the Fare Rules.");
      return;
    }

    const autoTrips = getAutoCancelTrips(selectedTravellers);


    const formData = new FormData();
    formData.append("booking_id", booking_id);
    formData.append("user_id", userLoggedInData.id);
    formData.append("submittion_type", "user");

    // ✅ Send remarks as object-like array
    Object.entries(Remarks).forEach(([key, value]) => {
      formData.append(`remarks[${key}]`, value);
    });

    // ✅ Send proceed_mode as object-like array
    Object.entries(ProceedMode).forEach(([key, value]) => {
      formData.append(`proceed_mode[${key}]`, value);
    });

    // formData.append("remarks", Remarks ?? "");
    // formData.append("proceed_mode", ProceedMode ? 1 : 0);

    // Attach traveller IDs
    selectedTravellers.forEach((id) => {
      formData.append("traveller_ids[]", id);
    });

    // Attach status types
    selectedStatuses.forEach((st) => {
      formData.append("status_types[]", st);
    });

    // Attach document (optional)
    Object.entries(Documents).forEach(([tripKey, docs]) => {
      docs.forEach((doc, idx) => {
        if (!doc.isExisting && doc.file) {
          formData.append(`documents[${tripKey}_${idx}][file]`, doc.file);
          formData.append(
            `documents[${tripKey}_${idx}][document_for]`,
            tripKey
          );
        }
      });
    });

    setSubmitting(true);
    try {
      const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

      const res = await axios.post(postApi, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("POST RESULT => ", res.data);
      toast.success("Cancellation request submitted!");
      onClose();
    } catch (err) {
      console.error("POST ERROR => ", err);
      toast.error("Failed to submit");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (warningMessage !== "") {
      const timer = setTimeout(() => {
        setWarningMessage("");
      }, 3000); // 3 seconds

      // cleanup to avoid memory leaks
      return () => clearTimeout(timer);
    }
  }, [warningMessage]);

  const REMARK_COOLDOWN_MS = 10 * 60 * 1000; // 10 minutes

  const getRemarkCooldownKey = () => `remark_cooldown_cancellation_${pendingEnquiry?.form_id}`;

  // Start countdown timer when cooldown is active
  useEffect(() => {
    if (!pendingEnquiry?.form_id) return;
    const stored = localStorage.getItem(getRemarkCooldownKey());
    if (stored) {
      const remaining = Math.ceil((parseInt(stored) + REMARK_COOLDOWN_MS - Date.now()) / 1000);
      if (remaining > 0) setRemarkCooldownSecs(remaining);
    }
  }, [pendingEnquiry?.form_id]);

  useEffect(() => {
    if (remarkCooldownSecs <= 0) return;
    const t = setInterval(() => {
      setRemarkCooldownSecs((prev) => {
        if (prev <= 1) { clearInterval(t); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [remarkCooldownSecs]);

  const handleSaveRemark = async () => {
    if (!newRemark.trim() && remarkFiles.length === 0) return;
    if (!pendingEnquiry?.form_id) return;
    if (remarkCooldownSecs > 0) return;
    try {
      setSavingRemark(true);
      const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
      const fd = new FormData();
      fd.append("air_booking_post_booking_forms_id", pendingEnquiry.form_id);
      if (newRemark.trim()) fd.append("remarks", newRemark.trim());
      remarkFiles.forEach((f) => fd.append("attachments[]", f));
      await axios.post(
        `${MAIN_URL}bookings/flights/post-booking-form-remarks`,
        fd,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      // Refresh remarks list
      const res = await axios.get(
        `${MAIN_URL}bookings/flights/post-booking-form-remarks/${pendingEnquiry.form_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setExistingRemarks(res.data.remarks || []);
      setNewRemark("");
      setRemarkFiles([]);
      // Start 10-minute cooldown
      localStorage.setItem(getRemarkCooldownKey(), Date.now().toString());
      setRemarkCooldownSecs(REMARK_COOLDOWN_MS / 1000);
      toast.success("Remark saved!");
    } catch (err) {
      console.error("Save remark error", err);
      toast.error("Failed to save remark");
    } finally {
      setSavingRemark(false);
    }
  };

  console.log("Documents is : ", Documents);

  // In readOnly mode (opened from Raised Requests), lock the form.
  // In normal Cancel Booking mode, always allow interaction regardless of pending status.
  const hasPending = readOnly && pendingEnquiry?.has_pending === true;
  const showRemarksPanel = hasPending;

  return (
    <div style={{ width: showRemarksPanel ? "1300px" : "1000px" }}>
      <div className="res--booking--header">
        <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
          <h3 style={{ margin: "0px" }}>Cancel Booking</h3>
          {requestId && (
            <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "3px 10px" }}>
              REQ #{requestId}
            </span>
          )}
          {warningMessage && (
            <p
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "white",
                padding: "5px 10px",
                borderRadius: "5px",
                background: "red",
              }}
            >
              {warningMessage}
            </p>
          )}
        </div>
        <img src={CloseIcon} alt="" />
      </div>
      {loading ? (
        <h4>Loading Please Wait...</h4>
      ) : (
        <div style={{ display: "flex", gap: 0, alignItems: "stretch" }}>
          {/* ── LEFT: form ── */}
          <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", position: "relative" }}>
          <div ref={scrollRef} style={{ maxHeight: "500px", overflow: "auto" }}>
            <div>
            {MainForm?.data?.form_data?.map((trip, trpIdx) => {
              const isTripDisabled = isTripPastOrDeparted(trip);

              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: isTripDisabled ? 0.5 : 1,
                    pointerEvents: isTripDisabled ? "none" : "auto",
                  }}
                  className={`fi--tripinfo--container fi--tripinfo--cancellation ${isTripDisabled ? "trip-disabled" : ""
                    }`}
                  key={trpIdx}
                >
                  <div className="fi--tripinfo--left">
                    {isTripDisabled && (
                      <span className="trip-disabled-text">
                        Flight already departed — cancellation not allowed
                      </span>
                    )}

                    <div className="ticket--head--userdb">
                      <div className="ticket--head--data--left">
                        <div className="ticket--onward-return--timings">
                          <div className="ticket--onward--return">
                            {trip?.main_heading} Flight Details
                          </div>
                        </div>

                        <div className="ticket--subflight--details">
                          {trip?.Head_Data?.map((hd, hdx) => {
                            return (
                              <div className="route--row" key={hdx}>
                                <div className="left--route--row">
                                  <div className="route--row--source">
                                    {trip?.Head_Data?.length > 2
                                      ? hd.airport_code_from
                                      : hd.from}
                                  </div>
                                  <div className="route--row--stops">
                                    -{" "}
                                    {hd.stops == 0
                                      ? "Non Stop"
                                      : `${hd.stops} Stops`}{" "}
                                    -
                                  </div>
                                  <div className="route--row--source">
                                    {trip?.Head_Data?.length > 2
                                      ? hd.airport_code_to
                                      : hd.to}
                                  </div>

                                  {hdx !== trip?.Head_Data?.length - 1 && ", "}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="ticket--head--data--right">
                        <img
                          className={`collapse-icon ${openTrips[trpIdx] ? "open" : ""
                            }`}
                          onClick={() => toggleTrip(trpIdx)}
                          src={CollapseIcon}
                          alt=""
                          srcset=""
                        />
                      </div>
                    </div>

                    {openTrips[trpIdx] && (
                      <>
                        {MainForm?.data?.form_data?.length == 1 && (
                          <div className="tripinfo--cancellation--wrapper">
                            <div className="tripinfo--content tripinfo--content--heading">
                              <div className="tripinfo--left--content">
                                <h4>Time Frame</h4>
                                <span>(From scheduled flight departure)</span>
                              </div>
                              <div className="tripinfo--right--content">
                                <h4>
                                  Airline Charges + Fare Difference + TripPrizer
                                  Charges
                                </h4>
                                <span>per traveller</span>
                              </div>
                            </div>
                            <div className="tripinfo--content">
                              <div className="tripinfo--left--content">
                                <h4>0 Hours to 4 Hours</h4>
                              </div>
                              <div className="tripinfo--right--content">
                                <ul className="tripinfo--content--list">
                                  <li>
                                    <label>Adult:</label>
                                    <span className="nr--red">
                                      Non-Refundable
                                    </span>
                                  </li>
                                  <li>
                                    <label>Child:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                  <li>
                                    <label>Infant:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="tripinfo--content">
                              <div className="tripinfo--left--content">
                                <h4>4 Hours to 4 Days</h4>
                              </div>
                              <div className="tripinfo--right--content">
                                <ul className="tripinfo--content--list">
                                  <li>
                                    <label>Adult:</label>
                                    <span className="nr--red">
                                      Non-Refundable
                                    </span>
                                  </li>
                                  <li>
                                    <label>Child:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                  <li>
                                    <label>Infant:</label>
                                    <span>
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      28,885 +{" "}
                                      <img
                                        src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                        alt=""
                                      />
                                      100
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}

                        {trip?.Data?.map((frame, frameIdx) => {
                          const isFrameDisabled = isTripDisabled || isFramePastOrDeparted(frame);
                          return (
                          <div
                            className="tripinfo--cancellation--wrapper"
                            key={frameIdx}
                            style={{ opacity: isFrameDisabled ? 0.5 : 1, pointerEvents: isFrameDisabled ? "none" : "auto" }}
                          >
                            <div className="tripinfo--head">
                              <div className="left--tripinfo--head">
                                <div className="left--int--ti--airlines">
                                  {frame.airlineLogos.length == 1 && (
                                    <div className="airline--img--container one--logo">
                                      <img src={frame.airlineLogos[0]} alt="" />
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 2 && (
                                    <div className="airline--img--container two--logos">
                                      <div className="twologos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="twologos-lastrow">
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 3 && (
                                    <div className="airline--img--container three--logos">
                                      <div className="threelogos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="threelogos-centerrow">
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="threelogos-lastrow">
                                        <img
                                          src={frame.airlineLogos[2]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {frame.airlineLogos.length == 4 && (
                                    <div className="airline--img--container four--logos">
                                      <div className="fourlogos-firstrow">
                                        <img
                                          src={frame.airlineLogos[0]}
                                          alt=""
                                        />
                                        <img
                                          src={frame.airlineLogos[1]}
                                          alt=""
                                        />
                                      </div>
                                      <div className="fourlogos-lastrow">
                                        <img
                                          src={frame.airlineLogos[2]}
                                          alt=""
                                        />
                                        <img
                                          src={frame.airlineLogos[3]}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  )}

                                  <ul className="left-int--tripinfo--airline">
                                    {frame.airlineNames?.map((i) => (
                                      <li>{i}</li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="sep">|</div>
                                <ul className="left-int--tripinfo--route">
                                  <li>{frame.journey.from}</li>
                                  <li>{frame.journey.to}</li>
                                </ul>
                              </div>
                              <div className="right--tripinfo--head">
                                <label for="">Fare Type :</label>
                                <span>{frame.fareName || "Normal Fare"}</span>
                              </div>
                            </div>

                            {MainForm?.data?.form_data?.length > 1 && (
                              <>
                                <div className="tripinfo--content tripinfo--content--heading">
                                  <div className="tripinfo--left--content">
                                    <h4>Time Frame</h4>
                                    <span>
                                      (From scheduled flight departure)
                                    </span>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <h4>
                                      Airline Charges + Fare Difference +
                                      TripPrizer Charges
                                    </h4>
                                    <span>per traveller</span>
                                  </div>
                                </div>
                                <div className="tripinfo--content">
                                  <div className="tripinfo--left--content">
                                    <h4>0 Hours to 4 Hours</h4>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <ul className="tripinfo--content--list">
                                      <li>
                                        <label>Adult:</label>
                                        <span className="nr--red">
                                          Non-Refundable
                                        </span>
                                      </li>
                                      <li>
                                        <label>Child:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                      <li>
                                        <label>Infant:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="tripinfo--content">
                                  <div className="tripinfo--left--content">
                                    <h4>4 Hours to 4 Days</h4>
                                  </div>
                                  <div className="tripinfo--right--content">
                                    <ul className="tripinfo--content--list">
                                      <li>
                                        <label>Adult:</label>
                                        <span className="nr--red">
                                          Non-Refundable
                                        </span>
                                      </li>
                                      <li>
                                        <label>Child:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                      <li>
                                        <label>Infant:</label>
                                        <span>
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          28,885 +{" "}
                                          <img
                                            src="https://tripprizer.com/static/media/frame-169-26.f68e7a4dc5128a589791.svg"
                                            alt=""
                                          />
                                          100
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="tripinfo--content">
                              <div className="tripinfo--reschedule--content">
                                <table cellpadding="0" cellspacing="0">
                                  <thead>
                                    <tr>
                                      <th width="300">
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <label
                                          className="tablecheckbox"
                                          htmlFor={`${trpIdx}-${frameIdx}-top`}
                                          style={{ display: "inline-flex", alignItems: "center" }}
                                        >
                                          <input
                                            type="checkbox"
                                            id={`${trpIdx}-${frameIdx}-top`}
                                            disabled={readOnly || isFrameDisabled}
                                            checked={!isFrameDisabled && frame.travellers
                                              .filter((t) => !t.is_blocked)
                                              .every((t) => selectedTravellers.includes(t.ref_id))}
                                            onChange={(e) => {
                                              const isChecked = e.target.checked;
                                              const unblocked = frame.travellers.filter((t) => !t.is_blocked || t.available_for_other_enquiry);
                                              const allIds = [];
                                              const allSts = [];
                                              unblocked.forEach((t) => {
                                                const { ids, sts } = getMatchingTravellers(t.full_name, t.date_of_birth, trpIdx);
                                                allIds.push(...ids);
                                                allSts.push(...sts);
                                              });
                                              const uniqueIds = Array.from(new Set(allIds));
                                              const uniqueSts = Array.from(new Set(allSts));
                                              if (isChecked) {
                                                setSelectedTravelers((prev) => Array.from(new Set([...prev, ...uniqueIds])));
                                                setSelectedStatuses((prev) => Array.from(new Set([...prev, ...uniqueSts])));
                                              } else {
                                                setSelectedTravelers((prev) => prev.filter((id) => !uniqueIds.includes(id)));
                                                setSelectedStatuses((prev) => prev.filter((st) => !uniqueSts.includes(st)));
                                              }
                                            }}
                                          />
                                          <img src={CheckBlueIcon} alt="" />
                                        </label>
                                        <span>Traveller (s)</span>
                                        </div>
                                      </th>
                                      <th>E-Ticket No.</th>
                                      <th>PNR</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {frame.travellers.map((trv, trvIdx) => {
                                      // In readOnly mode: highlight travellers selected for this specific enquiry
                                      // In normal mode: highlight travellers that have any enquiry_id (already submitted)
                                      const trvIds = trv.ref_id ? trv.ref_id.toString().split("-").map(Number) : [];
                                      const isThisEnquirySelected = readOnly && trvIds.some((id) => selectedEnquiryTravellerIds.includes(id));
                                      return (
                                        <tr key={trvIdx} style={isThisEnquirySelected ? { background: "#f3c954", cursor: "not-allowed" } : {}}>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <label
                                              className="tablecheckbox"
                                              htmlFor={`trv-${trpIdx}-${frameIdx}-${trvIdx}`}
                                              title={isThisEnquirySelected ? "Selected for this request" : trv.block_reason_text}
                                              style={{ display: "inline-flex", alignItems: "center", cursor: isThisEnquirySelected ? "not-allowed" : "pointer" }}
                                            >
                                              <input
                                                type="checkbox"
                                                id={`trv-${trpIdx}-${frameIdx}-${trvIdx}`}
                                                disabled={
                                                  readOnly ||
                                                  isFrameDisabled ||
                                                  (trv.is_blocked && !trv.available_for_other_enquiry) ||
                                                  isThisEnquirySelected
                                                }
                                                checked={!isFrameDisabled && selectedTravellers.includes(trv.ref_id)}
                                                onChange={(e) => {
                                                  const isChecked = e.target.checked;
                                                  const { ids: matchIds, sts: matchSts } = getMatchingTravellers(trv.full_name, trv.date_of_birth, trpIdx);
                                                  if (isChecked) {
                                                    setSelectedTravelers((prev) => Array.from(new Set([...prev, ...matchIds])));
                                                    setSelectedStatuses((prev) => Array.from(new Set([...prev, ...matchSts])));
                                                  } else {
                                                    setSelectedTravelers((prev) => prev.filter((id) => !matchIds.includes(id)));
                                                    setSelectedStatuses((prev) => prev.filter((st) => !matchSts.includes(st)));
                                                  }
                                                }}
                                              />
                                              <img src={CheckBlueIcon} alt="" />
                                            </label>
                                            <span>{trv.full_name}</span>
                                            </div>
                                          </td>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>{trv.ticket_number || "-"}</td>
                                          <td style={isThisEnquirySelected ? { cursor: "not-allowed" } : {}}>{trv.pnr || "-"}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        );
                        })}

                        <div className="choose--docs" style={{ flexDirection: "column", gap: "8px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <div className="left--docs--heading">
                              <h3>Documents <span>(Optional)</span></h3>
                              <p>Attach documents for this trip.</p>
                            </div>
                            {!readOnly && (
                              <label style={{
                                display: "inline-flex", alignItems: "center", gap: "4px",
                                fontSize: "11px", color: "#555", cursor: "pointer",
                                border: "1px solid #ccc", borderRadius: "4px",
                                padding: "4px 10px", background: "#fff", userSelect: "none",
                              }}>
                                <span>📎</span> Attach files
                                <input type="file" multiple style={{ display: "none" }}
                                  onChange={(e) => handleDocumentChange(`trip_${trpIdx + 1}`, e.target.files)}
                                />
                              </label>
                            )}
                          </div>

                          {Documents[`trip_${trpIdx + 1}`]?.length > 0 && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
                              {Documents[`trip_${trpIdx + 1}`].map((doc, idx) => (
                                <div key={idx} style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                  <a
                                    href={doc.isExisting ? fixUrl(doc.url) : doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "inline-flex", alignItems: "center", gap: "5px",
                                      fontSize: "11px", color: "#1565c0", textDecoration: "none",
                                      background: "#e3f2fd", borderRadius: "4px", padding: "3px 8px",
                                      border: "1px solid #bbdefb",
                                    }}
                                  >
                                    <span>{doc.name.endsWith(".pdf") ? "📄" : "🖼️"}</span>
                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "160px" }}>{doc.name}</span>
                                    {doc.isExisting && <span style={{ fontSize: "10px", color: "#388e3c", fontWeight: 600 }}>✓</span>}
                                  </a>
                                  {!doc.isExisting && !readOnly && (
                                    <button type="button" onClick={() => removeDocument(`trip_${trpIdx + 1}`, idx)}
                                      style={{ background: "none", border: "none", cursor: "pointer", color: "#e53935", fontSize: "13px", padding: "0 2px", lineHeight: 1 }}>
                                      ✕
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* <div className="choose--docs">
                          <div className="left--docs--heading">
                            <h3>
                              Documents <span>(Optional)</span>
                            </h3>
                            <p>
                              You can attach additional documents in support of
                              your refund application.
                            </p>
                          </div>
                          <div className="right--docs--attachment">
                            <input
                              type="file"
                              onChange={(e) => setDocuemnt(e.target.files[0])}
                            />
                          </div>
                        </div> */}

                        <div className="remarks--popup--userdb">
                          <label for="textarea--remarks">Remarks:</label>
                          <textarea
                            name=""
                            id=""
                            disabled={readOnly || isTripDisabled}
                            placeholder="Remarks"
                            value={Remarks[`user_remarks_${trpIdx + 1}`]}
                            onChange={(e) =>
                              setRemarks((prev) => ({
                                ...prev,
                                [`user_remarks_${trpIdx + 1}`]: e.target.value,
                              }))
                            }
                          ></textarea>
                        </div>

                        {/* <div
                          className="acceptcb"
                          onClick={() =>
                            setProceedMode((prev) => ({
                              ...prev,
                              [`proceed_mode_${trpIdx + 1}`]:
                                ProceedMode[`proceed_mode_${trpIdx + 1}`] != 1
                                  ? 1
                                  : 0,
                            }))
                          }
                        >
                          <input
                            disabled={readOnly || isTripDisabled}
                            type="checkbox"
                            checked={
                              ProceedMode[`proceed_mode_${trpIdx + 1}`] == 1
                            }
                          />{" "}
                          <label for="acceptfr">
                            Proceed by Ignoring Remarks
                          </label>
                        </div> */}

                        <div className="acceptcb">
                          <input
                            disabled={readOnly || isTripDisabled}
                            type="checkbox"
                            checked={
                              ProceedMode[`proceed_mode_${trpIdx + 1}`] == 1
                            }
                            onChange={() =>
                              !readOnly && setProceedMode((prev) => ({
                                ...prev,
                                [`proceed_mode_${trpIdx + 1}`]:
                                  ProceedMode[`proceed_mode_${trpIdx + 1}`] != 1
                                    ? 1
                                    : 0,
                              }))
                            }
                          />
                          <label>Proceed by Ignoring Remarks</label>
                        </div>

                        <div className="trips--flightdetails--summary">
                          <h3>Terms & Conditions:</h3>
                          <ul className="trips--fd--list">
                            <li>
                              The airline fee is indicative. TripPrizers does
                              not guarantee the accuracy of this information.
                            </li>
                            <li>
                              All fees mentioned are per passenger. Date change
                              charges are applicable only on selecting the same
                              airline on a new date. The difference in fares
                              between the old and the new booking will also be
                              payable by the user.
                            </li>
                            <li>
                              Please refer to the Date Change Charges section
                              above for details on the number of allowed free
                              date changes, if applicable
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
            </div>{/* end pointer-events wrapper */}
          </div>

          {/* bottom action bar — only shown when NOT in pending mode */}
          {showbottombar && !hasPending && (
            <div className="action--bar--bottom">
              {allTripsDisabled && (
                <div className="trip-disabled-warning">
                  All flights have already departed. Cancellation is no longer allowed.
                </div>
              )}
              {!allTripsDisabled && (
                <div className="acceptcb" onClick={() => setAcceptFareRules(!AcceptFareRules)}>
                  <input
                    type="checkbox"
                    disabled={autoFill?.autoFilled == true && autoFill.data.submittion_type != "user"}
                    checked={AcceptFareRules}
                  />{" "}
                  <label htmlFor="acceptfr">I Accept The Fare Rules.</label>
                </div>
              )}
              {!allTripsDisabled && (
                <button
                  type="button"
                  style={{
                    cursor: autoFill?.autoFilled == true && autoFill.data.submittion_type != "user" ? "not-allowed" : "pointer",
                    opacity: autoFill?.autoFilled == true && autoFill.data.submittion_type != "user" ? 0.6 : 1,
                    width: "max-content",
                  }}
                  title={autoFill?.autoFilled == true && autoFill.data.submittion_type != "user" ? "You can't update this form filled by user" : ""}
                  disabled={submitting || (autoFill?.autoFilled == true && autoFill.data.submittion_type != "user")}
                  className="ac-submitbtn"
                  onClick={handleSubmit}
                >
                  {submitting ? "Submitting..." : "Proceed"}
                </button>
              )}
            </div>
          )}
          </div>

          {/* ── RIGHT: remarks panel ── */}
          {showRemarksPanel && (
            <div style={{ width: "300px", flexShrink: 0, borderLeft: "1px solid #e0e0e0", display: "flex", flexDirection: "column", background: "#fff" }}>

              {/* Header */}
              <div style={{ padding: "12px 16px 10px", borderBottom: "1px solid #e0e0e0", background: "#f5f5f5" }}>
                <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#333" }}>Remarks</p>
                <p style={{ margin: "2px 0 0", fontSize: "11px", color: "#888" }}>Your request is with us — add a follow-up below.</p>
              </div>




              {/* Messages */}
              <div style={{ flex: 1, overflowY: "auto", padding: "12px 14px", display: "flex", flexDirection: "column", gap: "10px", minHeight: 0 }}>
                {existingRemarks.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#bbb", textAlign: "center", marginTop: "20px" }}>No remarks yet.</p>
                )}
                {existingRemarks.map((r, idx) => {
                  const isAdmin = !!r.admin_id;
                  const time = new Date(r.created_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
                  return (
                    <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: isAdmin ? "flex-start" : "flex-end" }}>
                      <div style={{
                        maxWidth: "88%",
                        background: isAdmin ? "#f0f4ff" : "#e8f5e9",
                        border: `1px solid ${isAdmin ? "#c5cae9" : "#c8e6c9"}`,
                        borderRadius: isAdmin ? "2px 10px 10px 10px" : "10px 2px 10px 10px",
                        padding: "8px 12px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                      }}>
                        {isAdmin && (
                          <p style={{ margin: "0 0 3px", fontSize: "10px", fontWeight: 700, color: "#5c6bc0", textTransform: "uppercase", letterSpacing: "0.4px" }}>Support</p>
                        )}
                        {r.remarks && <p style={{ margin: 0, fontSize: "12px", color: "#333", lineHeight: "1.5" }}>{r.remarks}</p>}
                        {r.attachments?.length > 0 && (
                          <div style={{ marginTop: r.remarks ? "6px" : 0, display: "flex", flexDirection: "column", gap: "4px" }}>
                            {r.attachments.map((att, ai) => {
                              const baseUrl = MAIN_URL.replace(/\/api\/?$/, "").replace(/\/$/, "");
                              const attUrl = att.file_path?.startsWith("http") ? att.file_path : `${baseUrl}${att.file_path}`;
                              return (
                              <a key={ai} href={attUrl} target="_blank" rel="noopener noreferrer"
                                style={{
                                  display: "inline-flex", alignItems: "center", gap: "5px",
                                  fontSize: "11px", color: "#1565c0", textDecoration: "none",
                                  background: "#e3f2fd", borderRadius: "4px", padding: "3px 8px",
                                  border: "1px solid #bbdefb",
                                }}>
                                <span>{att.file_name.endsWith(".pdf") ? "📄" : "🖼️"}</span>
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "160px" }}>{att.file_name}</span>
                              </a>
                            );})}
                          </div>
                        )}
                      </div>
                      <span style={{ fontSize: "10px", color: "#aaa", marginTop: "3px", paddingLeft: "4px", paddingRight: "4px" }}>{time}</span>
                    </div>
                  );
                })}
              </div>

              {/* Input area */}
              <div style={{ borderTop: "1px solid #e0e0e0", padding: "10px 14px 12px", display: "flex", flexDirection: "column", gap: "8px", background: "#fafafa" }}>
                <textarea
                  rows={3}
                  placeholder="Type your remark here..."
                  value={newRemark}
                  onChange={(e) => setNewRemark(e.target.value)}
                  style={{
                    width: "100%", borderRadius: "6px", border: "1px solid #ddd",
                    padding: "8px 10px", fontSize: "12px", resize: "none",
                    boxSizing: "border-box", background: "#fff",
                    outline: "none", lineHeight: "1.5", fontFamily: "inherit",
                  }}
                />
                <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                  <label style={{
                    display: "inline-flex", alignItems: "center", gap: "4px",
                    fontSize: "11px", color: "#555", cursor: "pointer",
                    border: "1px solid #ccc", borderRadius: "4px",
                    padding: "4px 10px", background: "#fff", userSelect: "none",
                  }}>
                    <span>📎</span> Attach files
                    <input type="file" multiple style={{ display: "none" }} onChange={(e) => setRemarkFiles((prev) => [...prev, ...Array.from(e.target.files)])} />
                  </label>
                  {remarkFiles.map((f, fi) => (
                    <span key={fi} style={{
                      display: "inline-flex", alignItems: "center", gap: "4px",
                      fontSize: "11px", background: "#e3f2fd", borderRadius: "4px",
                      padding: "3px 8px", border: "1px solid #bbdefb", maxWidth: "120px",
                    }}>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                      <button type="button" onClick={() => setRemarkFiles((prev) => prev.filter((_, i) => i !== fi))}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#c0392b", padding: 0, lineHeight: 1, flexShrink: 0 }}>✕</button>
                    </span>
                  ))}
                </div>
                <button
                  type="button"
                  disabled={savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0)}
                  onClick={handleSaveRemark}
                  style={{
                    padding: "9px 0",
                    background: savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0) ? "#90caf9" : "#1565c0",
                    color: "#fff", border: "none", borderRadius: "6px",
                    fontSize: "13px", fontWeight: 600,
                    cursor: savingRemark || remarkCooldownSecs > 0 || (!newRemark.trim() && remarkFiles.length === 0) ? "not-allowed" : "pointer",
                    width: "100%",
                  }}
                >
                  {savingRemark ? "Saving..." : remarkCooldownSecs > 0 ? `Wait ${Math.floor(remarkCooldownSecs / 60)}m ${remarkCooldownSecs % 60}s` : "Save Remarks"}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CancellationForm;

